module.exports = __webpack_public_path__ + "static/img/junior_marketing_v.7aad0884.png";